import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled, { useTheme } from 'styled-components'

import { FlexColumn, FlexRow } from '@/@bothrs-ui/web/components/layout'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { H4 } from '@/@bothrs-ui/web/components/typography/Heading'
import { StSourceCard } from './SourceCard.styled'

import type { IconProp } from '@fortawesome/fontawesome-svg-core'
import type { FC, ReactNode } from 'react'

export type SourceCardProps = {
  title: string
  badge?: ReactNode
  description?: string
  icon?: IconProp | { path: string; alt: string }

  ctaIcon?: IconProp
  onClick?: () => void
}

const SourceCard: FC<SourceCardProps> = ({
  title,
  description,
  icon,

  badge,
  ctaIcon,

  onClick,
}: SourceCardProps) => {
  const theme = useTheme()

  return (
    <StSourceCard onClick={onClick}>
      <FlexColumn gap={theme.UI.SpacingPx.Space3} flexGrow={1}>
        {/* ICON + TITLE */}
        <FlexRow alignItems='center' gap={theme.UI.Spacing.Space2}>
          {icon ? (
            typeof icon === 'object' && 'path' in icon ? (
              <img src={icon.path} alt={icon.alt} />
            ) : (
              <FontAwesomeIcon icon={icon} color={theme.Colors.Neutrals.Darkest} />
            )
          ) : null}
          <StTitle noMargin style={{ whiteSpace: 'normal' }}>
            {title}
          </StTitle>
          {badge}

          {/* CTA */}
          {ctaIcon ? <FontAwesomeIcon icon={ctaIcon} color={theme.Colors.Neutrals.Darkest} /> : null}
        </FlexRow>

        {/* DESCRIPTION */}
        {description ? (
          <Span type='BodySmallRegular' color={theme.Colors.Neutrals.Darker}>
            {description}
          </Span>
        ) : null}
      </FlexColumn>
    </StSourceCard>
  )
}

const StTitle = styled(H4)`
  text-wrap: auto;
`

export { SourceCard }
